import React, { useEffect } from 'react';
import ScrollContainer from '../../../Base/Components/ScrollContainer';
import LaboratoryResultsToDescribeListItem from './LaboratoryResultsToDescribeListItem';
import FlatList from '../../../Base/Components/FlatList';
import {
	LaboratoryResultMiseStatus,
	LaboratoryResultMise,
	PaginationOrderHow,
	useLaboratoryResultsMiseQuery,
	LaboratoryResultsMiseWhereInput,
} from '../../../../graphql/graphql';
import { useFlatDataList } from '../../../Base/Hooks/useFlatDataList';
import { useEffectAsync } from '../../../../helpers';

const WRAPPER_ID = 'laboratoryResultsToDescribeList';

interface Props {
	filter: LaboratoryResultsMiseWhereInput;
}

const LaboratoryResultsToDescribeList: React.FC<Props> = ({ filter }) => {
	const {
		flatData,
		pagination,
		getNextPage,
		appendData,
		updateItem,
		replaceData,
	} = useFlatDataList<LaboratoryResultMise>();

	const { data, isLoading, refetch, isFetching } =
		useLaboratoryResultsMiseQuery({
			where: filter,
			pagination: {
				...pagination,
				order: {
					key:
						filter?.status === LaboratoryResultMiseStatus.Done
							? 'note_At'
							: 'created_at',
					how:
						filter?.status === LaboratoryResultMiseStatus.Done
							? PaginationOrderHow.Desc
							: PaginationOrderHow.Asc,
				},
			},
		});

	const reloadList = async () => {
		const response = await refetch();
		replaceData(
			(response.data?.laboratoryResultsMise?.data as LaboratoryResultMise[]) ??
				[],
		);
	};

	useEffectAsync(async () => {
		await reloadList();
	}, []);

	useEffect(() => {
		appendData(
			(data?.laboratoryResultsMise?.data as LaboratoryResultMise[]) ?? [],
		);
	}, [data]);

	return (
		<ScrollContainer wrapperId={WRAPPER_ID}>
			<FlatList
				onRefresh={reloadList}
				onLoadMore={getNextPage}
				data={flatData}
				isLoading={isLoading || isFetching}
				hasMoreData={data?.laboratoryResultsMise?.meta?.hasNextPage || false}
				scrollableTargetId={WRAPPER_ID}
				renderItem={item => (
					<LaboratoryResultsToDescribeListItem
						item={item}
						onUpdate={(item: LaboratoryResultMise) => updateItem(item)}
						reloadList={reloadList}
					/>
				)}
			/>
		</ScrollContainer>
	);
};

export default LaboratoryResultsToDescribeList;
